// extracted by css-extract-rspack-plugin
export default {"container":"AdditionalMealExpenseEditOverlay_container__PA-O0","deductionItem":"AdditionalMealExpenseEditOverlay_deductionItem__+oMSG"};